import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import {Observable} from "rxjs";
import {UserInfoService} from "../../user-info.service";

@Injectable()
export class LoginPageGuard  {

  constructor(private userInfo: UserInfoService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.userInfo.loggedIn) {
      return true;
    } else {
      this.router.navigateByUrl(route.queryParamMap.get('return') || '/');
      return false;
    }
  }
}
